import React from "react";
import SectionLabel from "../../components/SectionLabel";
import LawPill from "../../components/LawPill";
import "./ArgumentsPanel.css";

const CATEGORY_LABELS = {
  legal: "Jurídico",
  factual: "Fato",
  practical: "Prático",
  moral: "Moral",
};

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.content : "";
}

export default function ArgumentsPanel({
  buildPath,
  caseStatus,
  caseClosed = false,
  argumentsList = [],
  legalArticles = [],
  view = "all",
}) {
  const hasArguments = argumentsList.length > 0;
  const isGenerating = caseStatus === "generating_arguments";
  const buttonLabel = isGenerating
    ? "Gerando..."
    : hasArguments
      ? "Reconstruir argumentos"
      : "Construir argumentos";
  const buildDisabled = isGenerating || caseClosed;
  const showActions = view === "all" || view === "actions";
  const showList = view === "all" || view === "list";

  return (
    <section className="trunfo-args" aria-label="Argumentos do caso">
      {showActions ? (
        <>
          <header className="trunfo-args__header">
            <SectionLabel tone="mute">Argumentos</SectionLabel>
            <p className="trunfo-args__lede">
              Use os documentos e o relato para montar as teses e o texto da reclamação.
            </p>
          </header>

          <div className="trunfo-args__actions">
            <form method="post" action={buildPath} className="trunfo-args__form">
              <input type="hidden" name="authenticity_token" value={csrfToken()} />
              <button type="submit" className="trunfo-args__build" disabled={buildDisabled}>
                {buttonLabel}
              </button>
            </form>
          </div>

          {isGenerating ? (
            <p className="trunfo-args__empty">
              Estamos montando os argumentos agora. Atualize a página em alguns segundos.
            </p>
          ) : null}

          {caseClosed && !isGenerating ? (
            <p className="trunfo-args__empty">
              Caso concluído. Os argumentos ficam disponíveis apenas para leitura.
            </p>
          ) : null}

          {legalArticles.length > 0 ? (
            <div className="trunfo-args__articles">
              <SectionLabel tone="mute">Base legal</SectionLabel>
              <ul className="trunfo-args__pills">
                {legalArticles.map((article) => (
                  <li key={article.code}>
                    <LawPill code={article.code} title={article.title} href={article.url} />
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </>
      ) : null}

      {showList && hasArguments ? (
        <ol className="trunfo-args__list">
          {argumentsList.map((argument) => (
            <li key={argument.id} className="trunfo-args__item">
              <header className="trunfo-args__item-head">
                <span className={`trunfo-args__badge trunfo-args__badge--${argument.category}`}>
                  {CATEGORY_LABELS[argument.category] ?? argument.category}
                </span>
                <h3 className="trunfo-args__title">{argument.title}</h3>
              </header>
              <p className="trunfo-args__body">{argument.body}</p>
              {argument.legal_article_code ? (
                <p className="trunfo-args__ref">Base: {argument.legal_article_code}</p>
              ) : null}
            </li>
          ))}
        </ol>
      ) : null}

      {showList && !hasArguments && !isGenerating ? (
        <p className="trunfo-args__empty">
          Ainda não há teses montadas. Volte à aba <strong>Argumentos</strong> e clique em{" "}
          <strong>Construir argumentos</strong>.
        </p>
      ) : null}
    </section>
  );
}
